<template>
  <v-simple-table>
    <thead>
      <tr class="header">
        <th v-for="(v, k) in columns" :key="k">
          <b>{{ v.text }}</b>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, i) in data" :key="i">
        <td v-for="(col, k) in columns" :key="k">
          <slot :name="`item.${col.value}`" :data=data :item="row" :column="col.value" :value="row[col.value]" :index="i">
            <slot :data=data :item="row" :column="col.value" :value="row[col.value]" :index="i">
              {{ row[col.value] }}
            </slot>
          </slot>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: "SimpleTable",
  props: {
    data: Array,
    columns: Array,
  },
};
</script>

<style scoped>
.row-bold td {
  font-weight: bold;
}

.header th {
  text-align: left !important;
}
th,
td {
  white-space: nowrap;
}
</style>
